import { PhoneEffects } from './phone.effects';

export const effects: any[] = [PhoneEffects];
